export class SpecSheetImages {
	constructor(productID) {
		this.productID = productID;
		this.family = this.productID.productFamily;
		this.seriesName = this.productID.productSeries;
		this.series = this.productID.selectedOptions.find(
			(current) => parseInt(current.position) === 2,
		).partnum;
		this.certification = this.productID.selectedOptions.find(
			(current) => parseInt(current.position) === 3,
		).partnum;
		this.lens = this.productID.selectedOptions.find(
			(current) => parseInt(current.position) === 4,
		).partnum;
		this.optics = this.productID.selectedOptions.find(
			(current) => parseInt(current.position) === 5,
		).partnum;
		this.cct = this.productID.selectedOptions.find(
			(current) => parseInt(current.position) === 6,
		).partnum;
		this.voltage = this.productID.selectedOptions.find(
			(current) => parseInt(current.position) === 7,
		).partnum;
		this.control = this.productID.selectedOptions.find(
			(current) => parseInt(current.position) === 9,
		).partnum;
		this.mountingOption = this.productID.selectedOptions.find(
			(current) => parseInt(current.position) === 10,
		).partnum;
		this.battery = this.productID.selectedOptions.find(
			(current) => parseInt(current.position) === 14,
		).partnum;

		this.images = this.handleSetImages();

		this.formattedImages = this.handleFormatImages();
	}

	getRHImages = () => {
		let beam;
		let diagram;
		let beamAlt;
		let product;

		const mediapath = "https://www.dialight.com/wp-content/uploads/2024/06/";

		switch (this.mountingOption) {
			case "C":
				diagram = "Dims_ReliantHighBay_US.jpg";
				break;
			case "E":
				diagram = "Dims_Reliant_HighBay_TandemSides_US.jpg";
				break;
			case "D":
				diagram = "Dims_Reliant_HighBay_TandemEnds_US.jpg";
				break;
		}

		switch (this.optics) {
			case "A":
				beam = "BeamDistribution_ReliantHighBay_Aisle.jpg";
				break;
			case "M":
				beam = "BeamDistribution_ReliantHighBay_Medium.jpg";
				break;
			case "P":
				beam = "BeamDistribution_ReliantHighBay_Uplight.jpg";
				beamAlt = "BeamDistribution_ReliantHighBay_Aisle.jpg";
				break;
			case "Q":
				beam = "BeamDistribution_ReliantHighBay_Uplight.jpg";
				beamAlt = "BeamDistribution_ReliantHighBay_Medium.jpg";
				break;
		}

		switch (this.control) {
			case "D":
			case "J":
			case "K":
				product = "Image_ReliantHighBay_Standard_US.jpg";
				break;
			case "F":
			case "G":
			case "H":
			case "L":
				product = "Image_ReliantHighBay_OccSensor_US.jpg";
				break;
		}

		const images = {
			diagram: `${mediapath}${diagram}`,
			product: `${mediapath}${product}`,
			beam: `${mediapath}${beam}`,
		};

		if (beamAlt) {
			images.beamAlt = `${mediapath}${beamAlt}`;
		}

		return images;
	};

	getGRPImages = () => {
		let diagram =
			this.series === "P4"
				? "https://www.dialight.com/wp-content/uploads/2024/04/Dims_GRPLinear_1244mmModel.jpg"
				: "https://www.dialight.com/wp-content/uploads/2024/04/Dims_GRPLinear_764mmModel-scaled.jpg";
		let product;

		if (this.cct === "G" || this.cct === "A") {
			product =
				"https://www.dialight.com/wp-content/uploads/2024/04/Image_GRPLinear_Green_Amber_Group-scaled.jpg";
		} else {
			if (this.series === "P4") {
				product =
					"https://www.dialight.com/wp-content/uploads/2024/04/Image_GRPLinear_1244mmModel-scaled.jpg";
			} else {
				product =
					"https://www.dialight.com/wp-content/uploads/2024/04/Image_GRPLinear_764mmModel-scaled.jpg";
			}
		}

		let beam = `https://www.dialight.com/wp-content/uploads/2024/04/BeamDistribution_GRPLinear_Medium.png`;

		const images = {
			diagram,
			product,
			beam,
		};

		return images;
	};

	getHighBayImages = () => {
		let beam;
		let diagram;
		let product;

		const mediapath = "https://www.dialight.com/wp-content/uploads/2024/03/";

		switch (this.optics) {
			case "E":
				beam = "BeamDistribution_HighBay_Oval.jpg";
				break;
			case "M":
				beam = "BeamDistribution_HighBay_Medium.jpg";
				break;
			case "N":
				beam = "BeamDistribution_HighBay_Narrow.jpg";
				break;
			case "W":
				beam = "BeamDistribution_HighBay_Wide.jpg";
				break;
			case "R":
				beam = "BeamDistribution_HighBay_Round.jpg";
				break;
		}

		switch (this.series) {
			case "HC":
			case "VC":
				diagram = "Dims_HighBay_IntegratedWiringBox-scaled.jpg";
				product = "Image_HighBay_IntegratedWiringBox-scaled.jpg";
				break;
			case "HW":
			case "VW":
				diagram = "Dims_HighBay_IntegratedWiringBox_Bracket.jpg";
				product =
					this.mountingOption === "A" || this.mountingOption === "Q"
						? "Image_HighBay_JunctionBox.jpg"
						: "Image_HighBay_IntegratedWiringBox_EMEA_APAC-scaled.jpg";
				break;
			case "HE":
			case "VE":
				switch (this.certification) {
					case "A":
					case "C":
					case "M":
					case "P":
						if (this.mountingOption === "A" || this.mountingOption === "Q") {
							product = "Image_HighBay_ATEX-scaled.jpg";
						} else {
							product = "Image_HighBay_CID1_Zone1-scaled.jpg";
						}
						break;
					case "E":
						if (this.mountingOption === "H" || this.mountingOption === "R") {
							product = "Image_HighBay_Hook_EMEA_APAC-scaled.jpg";
						} else if (
							this.mountingOption === "A" ||
							this.mountingOption === "Q"
						) {
							product = "Image_HighBay_ATEX-scaled.jpg";
						} else {
							product = "Image_HighBay_CordedModel.jpg";
						}
						break;
					case "D":
					case "U":
						if (this.battery === "G" || this.battery === "H") {
							product = "Image_HighBay_BatteryBackup-scaled.jpg";
						} else {
							product = "Image_HighBay_CordedModel.jpg";
						}
						break;
					default:
						break;
				}

				if (
					(this.battery === "G" || this.battery === "H") &&
					["H", "R", "N", "P"].includes(this.mountingOption)
				) {
					diagram = "Dims_HighBay_BatteryBackup_Hook-scaled.jpg";
				} else {
					switch (this.certification) {
						case "A":
						case "C":
						case "M":
						case "P":
							if (
								this.mountingOption === "H" ||
								this.mountingOption === "R" ||
								this.mountingOption === "N" ||
								this.mountingOption === "P"
							) {
								diagram = "Dims_HighBay_CID1_Zone1-scaled.jpg";
							} else {
								diagram = "Dims_HighBay_HE_Standard_Swivel-scaled.jpg";
							}
							break;
						case "D":
						case "U":
							if (this.mountingOption === "A" || this.mountingOption === "Q") {
								diagram = "Dims_HighBay_HE_Standard_Swivel-scaled.jpg";
							} else if (
								this.mountingOption === "H" ||
								this.mountingOption === "R"
							) {
								diagram = "Dims_HighBay_Standard_Hook_Loop-scaled.jpg";
							} else {
								diagram = "Dims_HighBay_Standard_Pendent-scaled.jpg";
							}
							break;
						case "E":
							if (this.mountingOption === "H" || this.mountingOption === "R") {
								diagram = "Dims_HighBay_Hook_EMEA_APAC-scaled.jpg";
							} else if (
								this.mountingOption === "N" ||
								this.mountingOption === "P"
							) {
								diagram = "Dims_HighBay_Standard_Pendent-scaled.jpg";
							} else {
								diagram = "Dims_HighBay_HE_Standard_Swivel-scaled.jpg";
							}
							break;
						default:
							break;
					}
				}
		}

		const images = {
			diagram: `${mediapath}${diagram}`,
			product: `${mediapath}${product}`,
			beam: `${mediapath}${beam}`,
		};

		return images;
	};

	getH7Images = () => {
		let beam;
		let diagram;
		let product;

		if (this.optics === "M") {
			beam = "BeamDistribution_HighOutput_HB_Medium.jpg";
		} else {
			beam = "BeamDistribution_HighOutput_HB_Narrow.jpg";
		}

		if (this.certification === "E") {
			diagram = "Dims_HighOutput_HighBay_H7_EMEA-scaled.jpg";
		} else {
			diagram = "Dims_HighOutput_HighBay_H7-scaled.jpg";
		}

		if (this.mountingOption === "H" || "R") {
			product = "Image_HighOutput_HighBay_H7_Hook-scaled.jpg";
		} else {
			product = "Image_HighOutput_HighBay_H7-scaled.jpg";
		}

		const mediapath = "https://www.dialight.com/wp-content/uploads/2023/12/";

		const images = {
			diagram: `${mediapath}${diagram}`,
			product: `${mediapath}${product}`,
			beam: `${mediapath}${beam}`,
		};

		return images;
	};

	getAreaLightImages = () => {
		let beam = "";

		// Beam diagram.
		switch (this.optics) {
			case "A":
				if (this.voltage === 2) {
					beam = "BeamDistribution_AreaLight_100_277_180";
				} else {
					beam = "BeamDistribution_AreaLight_347_480_180";
				}
				break;
			case "B":
				if (this.voltage === 2) {
					beam = "BeamDistribution_AreaLight_100_277_360";
				} else {
					beam = "BeamDistribution_AreaLight_347_480_360";
				}
				break;
			case "W":
				if (this.voltage === 2) {
					beam = "BeamDistribution_AreaLight_100_277_Wide";
				} else {
					beam = "BeamDistribution_AreaLight_347_480_Wide";
				}
				break;
			default:
				break;
		}

		const imageReferences = {
			A: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_PolycarbLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			B: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_EMEA_APAC-scaled.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_EMEA_APAC-scaled.jpg",
						product: "Image_AreaLight_SafeSite_ATEX_Zone1_Amber-scaled.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			C: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_PolycarbLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			E: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_PolycarbLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			F: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_CeilingMount.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_CeilingMount_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_CeilingMount.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			G: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_PolycarbLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			H: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_PolycarbLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			K: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_PolycarbLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			M: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_PolycarbLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			N: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_PolycarbLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			P: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_PolycarbLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			R: {
				5: {
					N: {
						diagram: "Dims_AreaLight_90StanchionMount_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_90StanchionMount.jpg",
					},
					F: {
						diagram:
							"Dims_AreaLight_BatteryBackup_90StanchionMount_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			S: {
				5: {
					N: {
						diagram:
							"Dims_AreaLight_45StanchionMount_PolycarbLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_45StanchionMount.jpg",
					},
					F: {
						diagram:
							"Dims_AreaLight_BatteryBackup_45StanchionMount_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_45StanchionMount.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			T: {
				5: {
					N: {
						diagram: "Dims_AreaLight_90StanchionMount_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_90StanchionMount.jpg",
					},
					F: {
						diagram:
							"Dims_AreaLight_BatteryBackup_90StanchionMount_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			U: {
				5: {
					N: {
						diagram: "Dims_AreaLight_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_PolycarbLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup_UMA.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup_UMA.png",
					},
				},
			},
			V: {
				5: {
					N: {
						diagram: "Dims_AreaLight_WallMount_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_PolycarbLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_WallMount_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_WallMount_GlassLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_GlassLens.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			W: {
				5: {
					N: {
						diagram: "Dims_AreaLight_45WallMount_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_45WallMount.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_45WallMount_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_45WallMount_GlassLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_45WallMount.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
			Y: {
				5: {
					N: {
						diagram: "Dims_AreaLight_ConveyorMount_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_ConveyorMount.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_PolycarbLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
				7: {
					N: {
						diagram: "Dims_AreaLight_ConveyorMount_GlassLens_US.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_ConveyorMount.jpg",
					},
					F: {
						diagram: "Dims_AreaLight_BatteryBackup_GlassLens_US-scaled.jpg",
						product: "Image_AreaLight_Vigilant_SafeSite_Battery_Backup.png",
					},
				},
			},
		};

		const mediapath = "https://www.dialight.com/wp-content/uploads/2023/11/";

		const images = {
			diagram: `${mediapath}${imageReferences[this.mountingOption][this.lens][this.battery].diagram}`,
			product: `${mediapath}${imageReferences[this.mountingOption][this.lens][this.battery].product}`,
			beam: `${mediapath}${beam}.jpg`,
		};

		return images;
	};

	// Low Bay images
	getLowBayImages = () => {
		let diagram = "";
		let product = "";

		switch (this.series) {
			case "LW":
			case "VW":
				if (this.lens === "L") {
					product =
						"https://www.dialight.com/wp-content/uploads/2023/07/Image_LowBay_IntegratedWiringBox_EMEA.jpg";
					if (this.control === "M") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/07/Dims_LowBay_IntegratedWiringBox_OccSensor-scaled.jpg";
					} else {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/08/Dims_HighBay_IntegratedWiringBox_OccSensor_EMEA-scaled.jpg";
					}
				} else if (this.control === "M") {
					product =
						"https://www.dialight.com/wp-content/uploads/2023/07/Image_LowBay_IntegratedWiringBox_OccSensor.jpg";
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/08/Dims_HighBay_IntegratedWiringBox_OccSensor_EMEA-scaled.jpg";
				} else {
					product =
						"https://www.dialight.com/wp-content/uploads/2023/07/Image_LowBay_IntegratedWiringBox_EMEA.jpg";
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/08/Dims_HighBay_IntegratedWiringBox_Bracket.jpg";
				}
				break;
			case "LC":
			case "VC":
				product =
					"https://www.dialight.com/wp-content/uploads/2023/07/Image_LowBay_LC_IntegratedWiringBox.jpg";
				if (this.lens === "L") {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/07/Dims_LowBay_LC_IntegratedWiringBox.jpg";
				} else {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/08/Dims_HighBay_IntegratedWiringBox-scaled.jpg";
				}
				break;
			case "LE":
			case "VE":
				product =
					"https://www.dialight.com/wp-content/uploads/2023/07/Image_LowBay_LE_CordedModel_01.jpg";
				if (this.lens === "L") {
					if (this.mountingOption === "N" || this.mountingOption === "P") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/07/Dims_LowBay_LE_CordedModel.jpg";
					}
					if (this.mountingOption === "H" || this.mountingOption === "R") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/08/Dims_LowBay_Hook-scaled.jpg";
					}
				} else {
					if (this.mountingOption === "H") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/08/Dims_LowBay_Hook-scaled.jpg";
					}

					if (this.mountingOption === "N" || this.mountingOption === "P") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/08/Dims_HighBay_Standard_Pendent.jpg";
					}
				}
				break;
			default:
				break;
		}

		const images = {
			product,
			diagram,
			beam: "https://www.dialight.com/wp-content/uploads/2023/07/BeamDistribution_LowBay_UltraWide.jpg",
		};

		return images;
	};

	getProSiteImages = () => {
		let diagram = "";
		let diagramAlt = "";
		let product = "";
		let beam = "";

		// Get the Product Image.
		switch (this.mountingOption) {
			case "E":
				if (this.series === "F1") {
					product =
						"https://www.dialight.com/wp-content/uploads/2023/09/Image_Floodlight_F1_AngledBracket-scaled.jpg";
				} else {
					product =
						"https://www.dialight.com/wp-content/uploads/2023/09/Image_Floodlight_F2_AngledBracket-scaled.jpg";
				}
				break;
			case "F":
				if (this.series === "F1") {
					product =
						"https://www.dialight.com/wp-content/uploads/2023/09/Image_Floodlight_F1_StraightBracket-scaled.jpg";
				} else {
					product =
						"https://www.dialight.com/wp-content/uploads/2023/09/Image_Floodlight_F2_StraightBracket-scaled.jpg";
				}
				break;
					"https://www.dialight.com/wp-content/uploads/2024/10/ProSite_Flood_HDbracket02.jpg";
			case 'H':
				product =
					'https://www.dialight.com/wp-content/uploads/2025/01/ProSite_Flood_HDbracket02_edited.jpg';
				break;
			case 'S':
				if (this.certification === 'F' || this.certification === 'D') {
					product =
						"https://www.dialight.com/wp-content/uploads/2023/09/Image_Floodlight_F1_SlipfitterBracket_Haz-scaled.jpg";
				} else {
					product =
						"https://www.dialight.com/wp-content/uploads/2023/09/Image_Floodlight_F1_SlipfitterBracket_NonHaz-scaled.jpg";
				}
				break;
			case "T":
				product =
					"https://www.dialight.com/wp-content/uploads/2023/09/Image_Floodlight_F2_HighMast.jpg";
				break;
			default:
				break;
		}

		// Get the Beam Distribution Image.
		switch (this.optics) {
			case "F":
				beam =
					"https://www.dialight.com/wp-content/uploads/2023/09/BeamDistribution_Floodlight_Asymmetric.jpg";
				break;
			case "4":
				beam =
					"https://www.dialight.com/wp-content/uploads/2023/09/BeamDistribution_Floodlight_NEMA4.jpg";
				break;
			case "6":
				beam =
					"https://www.dialight.com/wp-content/uploads/2023/09/BeamDistribution_Floodlight_NEMA6.jpg";
				break;
			case "7":
				beam =
					"https://www.dialight.com/wp-content/uploads/2023/09/BeamDistribution_Floodlight_NEMA7x6.jpg";
				break;
			case "J":
				beam =
					"https://www.dialight.com/wp-content/uploads/2023/09/BeamDistribution_Floodlight_AsymmetricWide.png";
				break;
			default:
				break;
		}

		switch (this.certification) {
			case "D":
			case "F":
				if (this.series === "F1") {
					if (this.mountingOption === "E") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Bracket_US-scaled.jpg";
						diagramAlt =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_US_Angle-scaled.jpg";
					} else if (this.mountingOption === "F") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Bracket_US-scaled.jpg";
						diagramAlt =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_US_Swivel-scaled.jpg";
					} else {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_Metric_SlipfitterUL844-scaled.jpg";
						diagramAlt =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_US_SlipfitterUL844-scaled.jpg";
					}
				} else if (this.mountingOption === "T") {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Model_US_HighMast-scaled.jpg";
				} else if (this.mountingOption === "E") {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Bracket_US-scaled.jpg";
					diagramAlt =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Model_US_Angle-scaled.jpg";
				} else {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Bracket_US-scaled.jpg";
					diagramAlt =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Model_US_Swivel-scaled.jpg";
				}
				break;
			case "U":
				if (this.series === "F1") {
					if (this.mountingOption === "E") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Bracket_US-scaled.jpg";
						diagramAlt =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_US_Angle-scaled.jpg";
					} else if (this.mountingOption === "F") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Bracket_US-scaled.jpg";
						diagramAlt =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_US_Swivel-scaled.jpg";
					} else {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_US_SlipfitterUL1598-scaled.jpg";
					}
				} else if (this.mountingOption === "T") {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Model_US_HighMast-scaled.jpg";
				} else if (this.mountingOption === "E") {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Bracket_US-scaled.jpg";
					diagramAlt =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Model_US_Angle-scaled.jpg";
				} else {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Bracket_US-scaled.jpg";
					diagramAlt =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Model_US_Swivel-scaled.jpg";
				}
				break;
			case "B":
			case "L":
				if (this.series === "F1") {
					if (this.mountingOption === "F") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Bracket_Metric-scaled.jpg";
						diagramAlt =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_Metric_Swivel-scaled.jpg";
					} else {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Bracket_Metric-scaled.jpg";
						diagramAlt =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_Metric_Angle-scaled.jpg";
					}
				} else if (this.mountingOption === "F") {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Bracket_Metric-scaled.jpg";
					diagramAlt =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Model_Metric_Swivel-scaled.jpg";
				} else {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Bracket_Metric-scaled.jpg";
					diagramAlt =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Model_Metric_Angle-scaled.jpg";
				}
				break;
			case "E":
				if (this.series === "F1") {
					if (this.mountingOption === "F") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Bracket_Metric-scaled.jpg";
						diagramAlt =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_Metric_Swivel-scaled.jpg";
					} else if (this.mountingOption === "E") {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Bracket_Metric-scaled.jpg";
						diagramAlt =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_Metric_Angle-scaled.jpg";
					} else {
						diagram =
							"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F1_Floodlight_Model_Metric_SlipfitterUL1598-scaled.jpg";
					}
				} else if (this.mountingOption === "F") {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Bracket_Metric-scaled.jpg";
					diagramAlt =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Model_Metric_Swivel-scaled.jpg";
				} else {
					diagram =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Bracket_Metric-scaled.jpg";
					diagramAlt =
						"https://www.dialight.com/wp-content/uploads/2023/09/Dims_F2_Floodlight_Model_Metric_Angle-scaled.jpg";
				}
				break;
			default:
				break;
		}

		const images = {
			product,
			diagram,
			diagramAlt,
			beam,
		};

		return images;
	};

	getStreetlightImages = () => {
		let diagram = "";
		let product = "";
		let beam = "";
		let uploadDirectory =
			"https://www.dialight.com/wp-content/uploads/2024/10/";
		let diagramDirectory =
			"https://www.dialight.com/wp-content/uploads/2025/01/"; // Diagrams were uploaded later, so need a different url for them.

		product = uploadDirectory + "ProSite_Streetlight01.jpg";

		// Get the Beam Distribution Image.
		switch (this.optics) {
			case "P":
				beam =
					uploadDirectory +
					"ProSite-Street-Light-Polar-Diagram-Type-II-Medium.png";
				break;
			case "Q":
				beam =
					uploadDirectory +
					"ProSite-Street-Light-Polar-Diagram-Type-III-Medium.png";
				break;
			case "J":
				beam =
					uploadDirectory +
					"ProSite-Street-Light-Polar-Diagram-Type-III-Short.png";
				break;
			case "6":
				beam =
					uploadDirectory + "ProSite-Street-Light-Polar-Diagram-Type-V.png";
				break;
			case "F":
				beam =
					"https://www.dialight.com/wp-content/uploads/2023/09/BeamDistribution_Floodlight_Asymmetric.jpg";
				break;
			case "4":
				beam =
					"https://www.dialight.com/wp-content/uploads/2023/09/BeamDistribution_Floodlight_NEMA4.jpg";
				break;
			case "7":
				beam =
					"https://www.dialight.com/wp-content/uploads/2023/09/BeamDistribution_Floodlight_NEMA7x6.jpg";
				break;
			default:
				break;
		}

		switch (this.mountingOption) {
			case "S":
				if (this.control === "S") {
					diagram = diagramDirectory + "s1xnxxxxssnxxg.jpg";
				} else {
					diagram = diagramDirectory + "s1xnxxxxdsnxxg.jpg";
				}
				break;
			case "T":
				if (this.control === "S") {
					diagram = diagramDirectory + "s1xnxxxxstnxxg.jpg";
				} else {
					diagram = diagramDirectory + "s1xnxxxxdtnxxg.jpg";
				}
				break;
			default:
				break;
		}

		const images = {
			product,
			diagram,
			beam,
		};

		return images;
	};

	handleSetImages = () => {
		let ssImages = null;

		switch (this.series) {
			case "F1":
			case "F2":
				ssImages = this.getProSiteImages();
				break;
			case "S1":
			case "S2":
				ssImages = this.getStreetlightImages();
				break;
			case "H7":
				ssImages = this.getH7Images();
				break;
			case "AL":
				ssImages = this.getAreaLightImages();
				break;
			case "LC":
			case "LE":
			case "LW":
				ssImages = this.getLowBayImages();
				break;
			case 'VC':
			case 'VE':
			case 'VW':
				if (this.seriesName.includes('High Bay')) {
					ssImages = this.getHighBayImages();
				} else {
					ssImages = this.getLowBayImages();
				}
				break;
			case "HC":
			case "HE":
			case "HW":
				ssImages = this.getHighBayImages();
				break;
			case "P2":
			case "P4":
				ssImages = this.getGRPImages();
				break;
			case 'RH':
				ssImages = this.getRHImages();
			default:
				break;
		}

		return ssImages;
	};

	handleFormatImages = () => {
		let sizedImages = null;

		switch (this.series) {
			case "F1":
			case "F2":
				sizedImages = {
					pageOneImage: { image: "product", fit: [175, 175] },
					pageTwoHeader: {
						image: "product",
						fit: [75, 75],
						alignment: "right",
					},
					dimensional: { image: "diagram", fit: [275, 130] },
					dimensionalAlt: { image: "diagramAlt", fit: [275, 130] },
					beamDiagram: { image: "beam", fit: [210, 112] },
				};
				break;
			case "S1":
			case "S2":
				sizedImages = {
					pageOneImage: { image: "product", fit: [175, 175] },
					pageTwoHeader: {
						image: "product",
						fit: [75, 75],
						alignment: "right",
					},
					dimensional: { image: "diagram", fit: [275, 130] },
					beamDiagram: { image: "beam", fit: [210, 112] },
				};
				break;
			case "H7":
				sizedImages = {
					pageOneImage: {
						image: "product",
						fit: [125, 125],
						margin: [0, 0, 0, 10],
					},
					pageTwoHeader: {
						image: "product",
						fit: [75, 75],
						alignment: "right",
					},
					dimensional: { image: "diagram", fit: [350, 200] },
					beamDiagram: { image: "beam", fit: [300, 150] },
				};
				break;
			case "AL":
				sizedImages = {
					pageOneImage: {
						image: "product",
						fit: [125, 125],
						margin: [0, 0, 0, 10],
					},
					pageTwoHeader: {
						image: "product",
						fit: [75, 75],
						alignment: "right",
					},
					dimensional: { image: "diagram", fit: [350, 200] },
					beamDiagram: { image: "beam", fit: [300, 150] },
				};
				break;
			case "LC":
			case "LE":
			case "LW":
				sizedImages = {
					pageOneImage: { image: "product", fit: [150, 150] },
					pageTwoHeader: {
						image: "product",
						fit: [75, 75],
						alignment: "right",
					},
					dimensional: { image: "diagram", fit: [350, 200] },
					beamDiagram: { image: "beam", fit: [150, 150] },
				};
				break;
			case "VC":
			case "VE":
			case "VW":
				if (this.seriesName.includes("High Bay")) {
					sizedImages = {
						pageOneImage: { image: "product", fit: [150, 150] },
						pageTwoHeader: {
							image: "product",
							fit: [75, 75],
							alignment: "right",
						},
						dimensional: { image: "diagram", fit: [350, 200] },
						beamDiagram: { image: "beam", fit: [300, 150] },
					};
				} else {
					sizedImages = {
						pageOneImage: { image: "product", fit: [150, 150] },
						pageTwoHeader: {
							image: "product",
							fit: [75, 75],
							alignment: "right",
						},
						dimensional: { image: "diagram", fit: [350, 200] },
						beamDiagram: { image: "beam", fit: [150, 150] },
					};
				}
				break;
			case 'HC':
			case 'HE':
			case 'HW':
				sizedImages = {
					pageOneImage: { image: "product", fit: [150, 150] },
					pageTwoHeader: {
						image: "product",
						fit: [75, 75],
						alignment: "right",
					},
					dimensional: { image: "diagram", fit: [400, 200] },
					beamDiagram: { image: "beam", fit: [300, 150] },
				};
				break;
			case "P2":
			case "P4":
				sizedImages = {
					pageOneImage: { image: "product", fit: [150, 150] },
					pageTwoHeader: {
						image: "product",
						fit: [90, 90],
						alignment: "right",
					},
					dimensional: { image: "diagram", fit: [350, 150] },
					beamDiagram: { image: "beam", fit: [300, 150] },
				};
				break;
			case 'RH':
				sizedImages = {
					pageOneImage: { image: "product", fit: [150, 150] },
					pageTwoHeader: {
						image: "product",
						fit: [90, 90],
						alignment: "right",
					},
					dimensional: { image: "diagram", fit: [350, 150] },
					beamDiagram: { image: "beam", fit: [300, 150] },
					beamDiagramAlt: { image: "beamAlt", fit: [300, 150] },
				};
				break;
			default:
				break;
		}
		return sizedImages;
	};
}
